export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

// A ORDEM DESTE OBJETO É A ORDEM DAS ABAS NA TELA, porque o filtro de permissão percorre as
// chaves na ordem em que foram escritas. Isso não é detalhe: a faixa de abas não cabe inteira na
// tela e rola na horizontal, então o que vem primeiro é o que a pessoa enxerga sem procurar.
//
// Até 14/10 a ordem era a de quem foi chegando: Spam nascia em primeiro lugar e "Minhas", que é
// o trabalho do dia, caía em quarto. A ordem agora é a do uso, da mais usada para a menos:
//
//   1. Minhas             o que é meu para fazer agora, e a aba em que a tela abre
//   2. Não atribuídas     fila esperando alguém pegar
//   3. Com o Bira         a fila viva da IA, para quem supervisiona olhar enquanto acontece
//   4. Aguardando parceiro  parado com terceiro: precisa de acompanhamento, não de agora
//   5. Todas              leitura de supervisão, visão larga
//   6. Spam               arquivo do que foi descartado, consulta eventual
//
// Quem é agente vê só Minhas, Aguardando parceiro e Spam (T-145), e nessa mesma ordem.
export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  // 14/10: "a fila dos atendimentos que estão no Bira está aparecendo em que tela?". Em
  // nenhuma, até aqui. Mesmas permissões das outras abas; quem a enxerga é decidido por perfil
  // no ChatList, porque é tela de quem supervisiona a IA, não de quem atende.
  bira: {
    count: 'biraCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  // 13/10: "Aguardando parceiro" é a sala de espera do próprio agente, então carrega as mesmas
  // permissões da aba "Minhas". Ela existe porque a conversa que foi para a Selia parou de ser
  // trabalho de hoje e continuava ocupando a fila dele; sem um lugar para ir, esconder seria
  // perder o caso de vista.
  pendencia: {
    count: 'pendenciaCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
  // T-284. A caixa de spam é de TODOS, e isso é a palavra da Tamara: "todas as pessoas que usam
  // a FanData conseguem ver essa pasta de spam". Por isso ela carrega as mesmas permissões da
  // aba "Minhas", a única que o agente também enxerga. Fica por último porque é consulta
  // eventual: ninguém começa o dia pelo que foi descartado.
  spam: {
    count: 'spamCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
};
